<template>
    <div>
        <multiselect v-model="value"
                     :placeholder="placeholder"
                     label="name"
                     track-by="id"
                     :options="registrables"
                     :multiple="true"></multiselect>
        <input type="hidden" v-for="(s, index) in value" :key="index" :name="inputName" :value="s.id">
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect'

    export default {
        components: {
            Multiselect
        },
        props: {
            registrables: {
                type: Array,
                default : [],
            },
            selected:  {
                type: Array,
                default: () => [],
            },
            placeholder: {
                type: String,
                default: '',
            },
            inputName: {
                type: String,
                default: '',
            },
          required: {
            type: Boolean,
            default: false,
          }
        },
        data () {
            return {
                value : [],
            }
        },
        mounted() {
          this.value = this.selected.length > 0 ?
            this.registrables.filter((registrable) => this.selected.find((s) => parseInt(s) === registrable.id) !== undefined)
            : this.registrables.length === 1 && this.required ? [this.registrables[0]] : [];
        }
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>